export const validateFirefoxBrowser = () => {
    if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1) {
        return true;
    } else {
        return false;
    }
};
